export default {
  BASE_URL: `${process.env.NODE_ENV === 'development' ? 'http://localhost:8090' : 'https://scanner.bdbildeler.no'}/auth/login`,
  // BASE_URL: 'https://scanner.bdbildeler.no/auth/login',
  API_URL: process.env.NODE_ENV === 'development' ? 'http://localhost:8090/api' : 'https://scanner.bdbildeler.no/api',
  // API_URL: 'https://scanner.bdbildeler.no/api',

  roles: {
    ReadOnly: 0,
    Master: 1,
    Norway: 2,
    Poland: 3,
    Merchant: 4,
  },
  locations: {
    rafe: [
      { value: null, text: 'Choose shelf' },
      { value: '1-V', text: '1-V' },
      { value: '1-H', text: '1-H' },
      { value: '2-V', text: '2-V' },
      { value: '2-H', text: '2-H' },
      { value: '3-V', text: '3-V' },
      { value: '3-H', text: '3-H' },
      { value: '4-V', text: '4-V' },
      { value: '4-H', text: '4-H' },
      { value: '5-V', text: '5-V' },
      { value: '5-H', text: '5-H' },
      { value: '6-V', text: '6-V' },
      { value: '6-H', text: '6-H' },
      { value: '7-V', text: '7-V' },
      { value: '7-H', text: '7-H' },
      { value: '8-V', text: '8-V' },
      { value: '8-H', text: '8-H' },
      { value: '9-V', text: '9-V' },
      { value: '9-H', text: '9-H' },
      { value: '10-V', text: '10-V' },
      { value: '10-H', text: '10-H' },
      { value: '11-V', text: '11-V' },
      { value: '11-H', text: '11-H' },
      { value: '12-V', text: '12-V' },
      { value: '12-H', text: '12-H' },
      { value: '13-V', text: '13-V' },
      { value: '13-H', text: '13-H' },
      { value: '14-V', text: '14-V' },
      { value: '14-H', text: '14-H' },
      { value: '15-V', text: '15-V' },
      { value: '15-H', text: '15-H' },
      { value: '16-V', text: '16-V' },
      { value: '16-H', text: '16-H' },
      { value: '17-V', text: '17-V' },
      { value: '17-H', text: '17-H' },
      { value: '18-V', text: '18-V' },
      { value: '18-H', text: '18-H' },
      { value: '19-V', text: '19-V' },
      { value: '19-H', text: '19-H' },
      { value: '20-V', text: '20-V' },
      { value: '20-H', text: '20-H' },
      { value: '21-V', text: '21-V' },
      { value: '21-H', text: '21-H' },
      { value: '22-V', text: '22-V' },
      { value: '22-H', text: '22-H' },
      { value: '23-V', text: '23-V' },
      { value: '23-H', text: '23-H' },
      { value: '24-V', text: '24-V' },
      { value: '24-H', text: '24-H' },
      { value: '25-V', text: '25-V' },
      { value: '25-H', text: '25-H' },
      { value: '26-V', text: '26-V' },
      { value: '26-H', text: '26-H' },
      { value: '27-V', text: '27-V' },
      { value: '27-H', text: '27-H' },
      { value: '28-V', text: '28-V' },
      { value: '28-H', text: '28-H' },
      { value: '29-V', text: '29-V' },
      { value: '29-H', text: '29-H' },
      { value: '30-V', text: '30-V' },
      { value: '30-H', text: '30-H' },
      { value: '31-V', text: '31-V' },
      { value: '31-H', text: '31-H' },
      { value: '32-V', text: '32-V' },
      { value: '32-H', text: '32-H' },
      { value: '33-V', text: '33-V' },
      { value: '33-H', text: '33-H' },
      { value: '34-V', text: '34-V' },
      { value: '34-H', text: '34-H' },
      { value: '35-V', text: '35-V' },
      { value: '35-H', text: '35-H' },
    ],
    kolone: [
      { value: null, text: 'Select number' },
      { value: '1', text: '1' },
      { value: '2', text: '2' },
      { value: '3', text: '3' },
      { value: '4', text: '4' },
      { value: '5', text: '5' },
      { value: '6', text: '6' },
      { value: '7', text: '7' },
      { value: '8', text: '8' },
      { value: '9', text: '9' },
      { value: '10', text: '10' },
      { value: '11', text: '11' },
      { value: '12', text: '12' },
      { value: '13', text: '13' },
      { value: '14', text: '14' },
      { value: '15', text: '15' },
      { value: '16', text: '16' },
      { value: '17', text: '17' },
      { value: '18', text: '18' },
      { value: '19', text: '19' },
      { value: '20', text: '20' },
      { value: '21', text: '21' },
      { value: '22', text: '22' },
      { value: '23', text: '23' },
      { value: '24', text: '24' },
      { value: '25', text: '25' },
      { value: '26', text: '26' },
      { value: '27', text: '27' },
      { value: '28', text: '28' },
      { value: '29', text: '29' },
      { value: '30', text: '30' },
    ],
    redovi: [
      { value: null, text: 'Select letter' },
      { value: 'A', text: 'A' },
      { value: 'B', text: 'B' },
      { value: 'C', text: 'C' },
      { value: 'D', text: 'D' },
      { value: 'E', text: 'E' },
      { value: 'F', text: 'F' },
      { value: 'G', text: 'G' },
      { value: 'H', text: 'H' },
      { value: 'I', text: 'I' },
      { value: 'J', text: 'J' },
    ],
  },
  localShelfCount: 90,
};
